import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ResbuildmngBuildingTypeOfCons extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  resbuildmngBuildingTypeOfConsState: this.props.resbuildmngBuildingTypeOfCons,
                  selectedResbuildmngBuildingTypeOfCons: {
                        value: this.props.resbuildmngBuildingTypeOfCons.resbuildmng_price_typeofcons_resbuildmng_typeofcons_id,
                        label: this.props.resbuildmngBuildingTypeOfCons.resbuildmng_typeofcons_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionResbuildmngBuildingTypeOfCons: [],
            }
      }
      componentDidMount() {
            this.getoptionResbuildmngBuildingTypeOfCons()
      }

      getoptionResbuildmngBuildingTypeOfCons = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_typeofcons_id, label: arr.data[k].resbuildmng_typeofcons_name })
                              }
                              self.setState({ optionResbuildmngBuildingTypeOfCons: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_typeofcons")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedResbuildmngBuildingTypeOfCons) => {
            var temparray = this.state.resbuildmngBuildingTypeOfConsState
            temparray.resbuildmng_price_typeofcons_resbuildmng_typeofcons_id = selectedResbuildmngBuildingTypeOfCons.value
            this.setState({ selectedResbuildmngBuildingTypeOfCons: selectedResbuildmngBuildingTypeOfCons, resbuildmngBuildingTypeOfConsState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.resbuildmngBuildingTypeOfConsState
            temparray.resbuildmng_price_typeofcons_percent = event
            this.setState({ resbuildmngBuildingTypeOfConsState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { resbuildmngBuildingTypeOfConsState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_typeofcons")
            fd.append("resbuildmng_price_typeofcons_id", resbuildmngBuildingTypeOfConsState.resbuildmng_price_typeofcons_id)
            fd.append("resbuildmng_price_typeofcons_percent", resbuildmngBuildingTypeOfConsState.resbuildmng_price_typeofcons_percent)

            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { resbuildmngBuildingTypeOfConsState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_typeofcons")
            fd.append("resbuildmng_price_typeofcons_id", resbuildmngBuildingTypeOfConsState.resbuildmng_price_typeofcons_id)

            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {
                  optionResbuildmngBuildingTypeOfCons,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedResbuildmngBuildingTypeOfCons,
                  resbuildmngBuildingTypeOfConsState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on">نوع نما</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"نوع نما"}
                                                value={selectedResbuildmngBuildingTypeOfCons}
                                                onChange={this.handleInstalmentMode}
                                                options={optionResbuildmngBuildingTypeOfCons}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          placeholder="درصد نوع نما "
                                          type="percent"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={resbuildmngBuildingTypeOfConsState.resbuildmng_price_typeofcons_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ResbuildmngBuildingTypeOfCons)
